import { Suspense } from "react";
import { Box, Flex, SimpleGrid } from "@chakra-ui/react";

import { useGetAppointment } from "modules/appointment/infrastructure/useGetAppointment";

import { ChakraText } from "components/ChakraText";
import { CustomColorScheme } from "components/Button";
import { ErrorBoundary } from "components/ErrorBoundary";
import { MainPageButton } from "components/MainPageButton";

import { RedirectToAppointmentButton } from "./RedirectToAppointmentButton";

interface IProps {
  appointmentId: string | number;
}

const AdditionalInformationThrowable = ({ appointmentId }: IProps) => {
  const { data: appointment } = useGetAppointment(appointmentId);

  return (
    <Box my={10}>
      <ChakraText w="70%" mx="auto" textAlign="center">
        W celu kontynuacji rezerwacji wybierz opcję Kontynuuj
      </ChakraText>
      <SimpleGrid
        my={10}
        w="70%"
        mx="auto"
        minChildWidth="200px"
        justifyContent="center"
        spacing={4}
      >
        <MainPageButton customColorScheme={CustomColorScheme.Blue} />
        {appointment && appointment.groupId && appointment.queueId && (
          <RedirectToAppointmentButton
            appointmentId={appointmentId}
            groupId={appointment.groupId}
            queueId={appointment.queueId}
          />
        )}
      </SimpleGrid>
    </Box>
  );
};

const AdditionalInformation = ({ ...props }: IProps) => {
  return (
    <ErrorBoundary
      fallback={() => (
        <Suspense fallback={() => <></>}>
          <Flex>
            <MainPageButton />
          </Flex>
        </Suspense>
      )}
    >
      <AdditionalInformationThrowable {...props} />
    </ErrorBoundary>
  );
};

export { AdditionalInformation };
